module.exports = __webpack_public_path__ + "img/color-fill-1_en.02ec2b0.jpg";